<template>
  <div>
    <template v-if="time && time.status && !isEdit">
      <div>
        <v-layout wrap align-center>
          <v-flex xs12 sm4 class="text-xs-left pb-2 pt-2">
            <Typography h4 medium :label="$t(name)" />
          </v-flex>
          <v-flex xs12 sm7 lg7 class="text-xs-center pb-2 pt-2">
            <div
              class="pa-2 color-darkBlue"
              style="
                border: 1px solid;
                border-radius: 6px;
                display: flex;
                flex-direction: row;
                gap: 10px;
              "
            >
              <img
                src="/static/img/time.png"
                alt
                class="responsive-img"
                style="height: 24px; width: 24px"
              />
              <Typography
                style="width: 100px; display: flex;"
                h5
                medium
                :label="openat ? `${openat.time} น.` : '00:00 น.'"
              />
              <img
                src="/static/img/SwapRight.png"
                alt
                class="responsive-img"
                style="height: 24px"
              />
              <Typography h5 medium :label="closeat ? `${closeat.time} น.` : '23:59 น.'" />
            </div>
          </v-flex>
          <v-flex xs12 sm1 lg1 class="text-xs-center pb-2 pt-2"></v-flex>
        </v-layout>
      </div>
    </template>
    <template v-if="isEdit">
      <v-layout wrap align-center>
        <v-flex xs12 sm4 class="text-xs-left pb-2 pt-2">
          <v-checkbox v-model="time.status" color="primary" class="ma-0 pa-0 timeCheckbox">
            <template v-slot:label>
              <div>
                <Typography h4 medium :label="$t(name)" />
              </div>
            </template>
          </v-checkbox>
        </v-flex>
        <v-flex xs12 sm7 lg7 class="text-xs-center pb-2 pt-2">
          <div
            class="pa-2 color-darkBlue"
            style="
              border: 1px solid;
              border-radius: 6px;
              display: flex;
              flex-direction: row;
              gap: 10px;
            "
          >
            <img
              src="/static/img/time.png"
              alt
              class="responsive-img"
              style="height: 24px; width: 24px"
            />
            <multiselect
              class="timepickerOpen"
              v-model="openat"
              :options="timeOptions"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
              :custom-label="timeLabel"
            ></multiselect>
            <img src="/static/img/SwapRight.png" alt class="responsive-img" style="height: 24px" />
            <multiselect
              class="timepickerClose"
              v-model="closeat"
              :options="timeOptions"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
              :custom-label="timeLabel"
            ></multiselect>
          </div>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Typography from '@/components/elements/Typography.vue'
export default {
  inject: ['$validator'],
  props: ['value', 'name', 'isEdit'],
  components: {
    Multiselect,
    Typography,
  },
  data() {
    return {
      time: null,
      showOpenat: false,
      showCloseat: false,
      timeOptions: [],
    }
  },
  created: function () {
    for (let index = 0; index <= 24; index++) {
      this.timeOptions.push({ time: index.toString().padStart(2, '0') + ':00' })
      if (index != 24) {
        this.timeOptions.push({ time: index.toString().padStart(2, '0') + ':30' })
      }
    }
  },
  computed: {
    openat: {
      get() {
        if (this.time && this.time.openat) {
          return { time: this.time.openat.split('+')[0] }
        } else {
          return { time: '00:00' }
        }
      },
      set(value) {
        if (value) {
          this.time.openat = value['time'] + '+07'
        } else {
          this.time.openat = '00:00+07'
        }
      },
    },
    closeat: {
      get() {
        if (this.time && this.time.closeat) {
          return { time: this.time.closeat.split('+')[0] }
        } else {
          return { time: '24:00' }
        }
      },
      set(value) {
        if (value) {
          this.time.closeat = value['time'] + '+07'
        } else {
          this.time.closeat = '24:00+07'
        }
      },
    },
  },
  mounted: function () {
    this.time = this.value
  },
  watch: {
    value: function (newVal, oldVal) {
      this.time = this.value
    },
  },
  methods: {
    timeLabel({ time }) {
      return `${time} น.`
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/billing/OpenTimeBotItem.vue